import { GlobalButtonStyle } from '@website-builder/model/style/global-button-style';

export class TabsButtonStyle extends GlobalButtonStyle {
  marginTop = 'uk-margin-top';

  static normalize(styles: Partial<TabsButtonStyle>): TabsButtonStyle {
    const globalButtonStyle: GlobalButtonStyle = GlobalButtonStyle.normalize(styles);
    const pureStyles = new TabsButtonStyle();

    Object.assign(pureStyles, globalButtonStyle);

    pureStyles.marginTop = styles.marginTop ?? pureStyles.marginTop;

    return pureStyles;
  }
}
